const customMessages = {}

customMessages.customizeMessage = function (item, text, caretPostion) {
  try {
    let newText = text || ''
    if (newText !== '') {
      const spliceStr = function (src, idx, rem, str) {
        return src.slice(0, idx) + str + src.slice(idx + Math.abs(rem))
      }
      newText = spliceStr(text, caretPostion, 0, `${item}`)
    } else {
      newText = item
    }
    return newText
  } catch (err) {}
}

export default customMessages
